import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconTwSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="22" height="16" viewBox="0 0 22 16" fill="none"
             className={classNames(['svg-icon svg-tw', className])}>
            <path
                d="M21.6654 1.89415C20.872 2.21538 20.0267 2.42831 19.1454 2.53169C20.052 2.032 20.744 1.24677 21.0694 0.300308C20.224 0.765538 19.2907 1.09415 18.296 1.27754C17.4934 0.488616 16.3494 0 15.1014 0C12.68 0 10.7307 1.81415 10.7307 4.03815C10.7307 4.35815 10.76 4.66585 10.832 4.95877C7.19603 4.79508 3.9787 3.18646 1.81736 0.736C1.44003 1.34031 1.2187 2.032 1.2187 2.77662C1.2187 4.17477 1.9987 5.41415 3.16136 6.13169C2.4587 6.11938 1.76936 5.93108 1.18536 5.63446C1.18536 5.64677 1.18536 5.66277 1.18536 5.67877C1.18536 7.64062 2.70136 9.27015 4.68936 9.64554C4.33336 9.73538 3.94536 9.77846 3.5427 9.77846C3.2627 9.77846 2.98003 9.76369 2.7147 9.70954C3.28136 11.3083 4.88936 12.4837 6.80136 12.5218C5.31336 13.5963 3.42403 14.2437 1.3787 14.2437C1.02003 14.2437 0.676031 14.2289 0.332031 14.1883C2.26936 15.3415 4.56536 16 7.04136 16C15.0894 16 19.4894 9.84615 19.4894 4.512C19.4894 4.33354 19.4827 4.16123 19.4734 3.99015C20.3414 3.42154 21.0707 2.71138 21.6654 1.89415Z"
                fill={color}/>
        </svg>

    );
};

IconTwSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconTwSVG.defaultProps = {
    color: '#fff',
    className: '',
};

export default IconTwSVG;